export const VAT = require('./vat')

export default {
  VAT,
}



// WEBPACK FOOTER //
// ./src/constants/index.js